import  { 
  FETCH_SERVICE_REQUEST_DETAILS,
  GET_CATEGORY_LIST,
  GET_SUB_CATEGORY_LIST,
  FETCH_CUSTOMER_USER_DETAILS,
  FETCH_CUSTOMER_BANK_DETAILS,
  CREATE_SERVICE_REQUEST,
  FETCH_SR_STATUS_OPTIONS,
  UPDATE_SR_STATUS,
  RESET_ERROR_STATE,
  RESET_CUSTOMER_DATA,
  RESET_SR_DATA,
} from "./actionTypes";

const initialState = {
  category : null,
  subCategory: null,
  customerDetails: null,
  serviceRequestDetails: null,
  srDetails: null,
  srUserDetails: null,
  srMessages: null, 
  srStatus: null,
  srUpdateStatusId: null,
  srUpdateOptions: [],
  newlyCreatedSRId: null,
  fetchServicerRequestDetailsStart:null,
  fetchCutomerUserDetailsStart: null,
  fetchCutomerBankDetailsStart: null,
  fetchSrOptionsStart: null,
  updateSrStatusStart: null,
  error: null
};

const srLabelKeyMap = { 
  fdId: "Fresh Desk ID",
  srId: "Service Request ID",
  category: "Category",
  subCategory: "Sub-Category",
  issue: "Issue",
  // docUrl: "Documents"
};

const userLabelKeyMap = {
  userName: "User's Name",
  emailId: "User's Email",
  mobileNumber: "Mobile Number",
  accountNumber: "Account Number",
};

function fetchServicerRequestDetailsStart(state){
  return {
    ...state,
    error: null,
    fetchServicerRequestDetailsStart: true
  };
};

function fetchServicerRequestDetailsSuccess(state,data){
  const { srDetails, userDetails, messages, status, srUpdateStatusId } = data?.data;

  const updateSRDetails = {
    title: "Service Request Details",
    descItems: Object.keys(srDetails).map(itemKey => { //eslint-disable-line array-callback-return
      if(srDetails?.[itemKey] && srLabelKeyMap?.[itemKey]){
        return {
          key: itemKey, 
          label: srLabelKeyMap[itemKey], 
          value: srDetails[itemKey]
        }
      }
    }), 
  };

  const UpdateUserDetails = {
    title:"User Details",
    descItems: Object.keys(userDetails).map(itemKey => { //eslint-disable-line array-callback-return
      if(userDetails?.[itemKey]){
        return {
          key: itemKey, 
          label: userLabelKeyMap[itemKey], 
          value: userDetails[itemKey] 
        }
      }
    }), 
  };
  
  return {
    ...state,
    error: null,
    fetchServicerRequestDetailsStart: false,
    serviceRequestDetails: data?.data,
    srDetails: updateSRDetails,
    srUserDetails: UpdateUserDetails,
    srMessages: messages,
    srStatus: status,
    srUpdateStatusId,
  };
}

function fetchServicerRequestDetailsError(state, data){
  return {
    ...state,
    fetchServicerRequestDetailsStart: false,
    error: data
  };
}



export default function srReducer(state=initialState,action) {
  switch(action.type){
    case `${FETCH_SERVICE_REQUEST_DETAILS}_START`:
      return fetchServicerRequestDetailsStart(state,action.data);
    case `${FETCH_SERVICE_REQUEST_DETAILS}_SUCCESS`:
      return fetchServicerRequestDetailsSuccess(state, action.data);     
    case `${FETCH_SERVICE_REQUEST_DETAILS}_ERROR`:
      return fetchServicerRequestDetailsError(state,action.data);
    case `${GET_CATEGORY_LIST}_START`:
      return {
        ...state,
        error: null,
      };
    case `${GET_CATEGORY_LIST}_SUCCESS`:
      return {
        ...state,
        category: action?.data?.category,
        error: null,
      };
    case `${GET_CATEGORY_LIST}_ERROR`:
      return {
        ...state,
        error: action.data,
      };
    case `${GET_SUB_CATEGORY_LIST}_START`:
      return {
        ...state,
        error: null
      };
    case `${GET_SUB_CATEGORY_LIST}_SUCCESS`:
      return {
        ...state,
        error: null,
        subCategory: action?.data?.subCategory
      };
    case `${GET_SUB_CATEGORY_LIST}_ERROR`:
      return {
        ...state,
        error: action.data,
      };
    case `${FETCH_CUSTOMER_USER_DETAILS}_START`:
      return { 
        ...state,
        error: null,
        fetchCutomerUserDetailsStart: true,
      };
    case `${FETCH_CUSTOMER_USER_DETAILS}_SUCCESS`:
      return {
        ...state,
        error: null,
        customerDetails: {
          ...(state?.customerDetails && { ...state.customerDetails}),
          userDetails: action.data?.USER_DETAILS
        },
        fetchCutomerUserDetailsStart: false,
      };
    case `${FETCH_CUSTOMER_USER_DETAILS}_ERROR`:
      return { 
        ...state,
        fetchCutomerUserDetailsStart: false,
        customerDetails: null,
        error: action.data
      };
    case `${FETCH_CUSTOMER_BANK_DETAILS}_START`:
      return { 
        ...state,
        error: null,
        fetchCutomerBankDetailsStart: true,
      };
    case `${FETCH_CUSTOMER_BANK_DETAILS}_SUCCESS`:
      const { BANK_DETAILS } = action.data;
      return {
        ...state,
        customerDetails: {
          ...(state?.customerDetails && { ...state.customerDetails}),
          bankDetails: BANK_DETAILS?.accountDetails,
          cardDetails: BANK_DETAILS?.cardDetails,
        },
        fetchCutomerBankDetailsStart: false,
        error: null,
      };
    case `${FETCH_CUSTOMER_BANK_DETAILS}_ERROR`:
      return { 
        ...state,
        fetchCutomerBankDetailsStart: false,
        error: action.data
      };
    case `${CREATE_SERVICE_REQUEST}_STAT`:
      return {
        ...state,
        createServiceRequestStart: true,
        error: null,
      }
    case `${CREATE_SERVICE_REQUEST}_SUCCESS`:
      const { serviceReqNo } = action.data;
      return {
        ...state,
        createServiceRequestStart: false,
        newlyCreatedSRId: serviceReqNo,
        error: null,
      }
    case `${CREATE_SERVICE_REQUEST}_ERROR`:
      return {
        ...state,
        createServiceRequestStart: false,
        error: action.data
      }
    case `${FETCH_SR_STATUS_OPTIONS}_STAT`:
      return {
        ...state,
        fetchSrOptionsStart: true,
        error: null,
      }
    case `${FETCH_SR_STATUS_OPTIONS}_SUCCESS`:
      return {
        ...state,
        fetchSrOptionsStart: false,
        error: null,
        srUpdateOptions: action.data.status,
      }
    case `${FETCH_SR_STATUS_OPTIONS}_ERROR`:
      return {
        ...state,
        fetchSrOptionsStart: false,
        error: action.data
      }
    case `${UPDATE_SR_STATUS}_STAT`:
      return {
        ...state,
        updateSrStatusStart: true,
        error: null,
      }
    case `${UPDATE_SR_STATUS}_SUCCESS`:
      return {
        ...state,
        updateSrStatusStart: false,
        error: null,
      }
    case `${UPDATE_SR_STATUS}_ERROR`:
      return {
        ...state,
        updateSrStatusStart: false,
        error: action.data
      }
    case RESET_ERROR_STATE:
      return {
        ...state,
        error: null,
      }
    case RESET_CUSTOMER_DATA: 
      return {
        ...state,
        customerDetails: null,
        error: null,
      }
    case RESET_SR_DATA: 
      return {
        ...initialState
      };
    default:
      return { ...state };
  }
}